/**
 * Molchanovs Move - Application Entry Point
 *
 * Minimal entry point that delegates to the FSD app layer.
 * All initialization, providers, and routing are handled by @app.
 *
 * URL Structure:
 * - /:locale/ - Public marketplace
 * - /:locale/instructor/* - Instructor dashboard (protected)
 * - /:locale/student/* - Student portal (protected)
 * - /:locale/admin/* - Admin panel (protected)
 * - /healthz - Health check endpoint
 *
 * @updated DOC-0074 (2025-12-19) - Added auth context to router
 * @updated DOC-0100 (2025-12-26) - Migrated to FSD app layer
 */

import { createRoot } from 'react-dom/client';
import { AppProviders } from '@app';

// Get root element
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Render the application
// AppProviders includes: StrictMode > QueryClient > AuthProvider > AbilityProvider > Router
createRoot(rootElement).render(<AppProviders />);
